import * as React from 'react'
import {
  FormControl,
  Grid,
  IconButton,
  InputAdornment,
  InputLabel,
  OutlinedInput,
} from '@mui/material'
import ModeEditOutlinedIcon from '@mui/icons-material/ModeEditOutlined'
import { useDispatch } from 'react-redux'
import moment from 'moment'
import { useTranslation } from 'react-i18next'

import { FilterItem } from 'types/FilterBuilder'
import { toggleFilterByLastSeenDialog as openLastSeenFilterDialog } from 'redux/slices/FilterBuilder'
import { DEFAULT_DATE_FORMAT } from 'lib/participants/Constants'

type Props = {
  item: FilterItem
  index: number
}

const LastSeenFilterPill = ({ item }: Props) => {
  const { t } = useTranslation()

  const mapLabel = () => {
    switch (item.type) {
      case 'lastSeenBefore':
        return t('filters.lastSeen.labelDateBefore')
      case 'lastSeenAfter':
        return t('filters.lastSeen.labelDateAfter')
      case 'lastSeenMoreThan':
        return t('filters.lastSeen.labelDaysMoreThan')
      case 'lastSeenLessThan':
        return t('filters.lastSeen.labelDaysLessThan')
    }
  }

  const mapValue = () => {
    switch (item.type) {
      case 'lastSeenBefore':
      case 'lastSeenAfter':
        return moment(item.UIValue).format(DEFAULT_DATE_FORMAT)
      case 'lastSeenMoreThan':
      case 'lastSeenLessThan':
        return `${item.value} ${t('filters.lastSeen.daysAgo')}`
    }
  }

  const dispatch = useDispatch()

  const handleClick = () => dispatch(openLastSeenFilterDialog())

  return (
    <Grid>
      <FormControl sx={{ width: 200 }}>
        <InputLabel>{mapLabel()}</InputLabel>
        <OutlinedInput
          label={mapLabel()}
          value={mapValue()}
          size="small"
          endAdornment={
            <InputAdornment position="end">
              <IconButton onClick={handleClick}>
                <ModeEditOutlinedIcon sx={{ fontSize: 20 }} />
              </IconButton>
            </InputAdornment>
          }
          readOnly
          sx={{ pr: 0 }}
        />
      </FormControl>
    </Grid>
  )
}

export default LastSeenFilterPill
